import React from "react"
import PropTypes from "prop-types"
import Logos from "components/Logos"
import Content from "components/Content"
import CTASection from "components/CTASection"
import Newsletter from "components/Newsletter"
import CasePortfolio from "components/CasePortfolio"
import ContentSimple from "components/ContentSimple"
import ContentBlock from "components/ContentBlock"
import ContentCardSlice from "components/ContentCardSlice"
import ParagraphImage from "components/ParagraphImage"
import SingleProduct from "components/Product/SingleProduct"
import ProductGrid from "components/Product/Grid"
import ProductCategoryGrid from "components/Product/CategoryGrid"
import Articles from "components/Articles"
import CTAButton from "components/CTAButton"
import About from "components/About"

function SliceZone({ ...props }) {
  const { slices } = props

  const slice = slices?.map((s, i) => {
    switch (s.type) {
      case "paragraph___image":
        return <ParagraphImage key={`${s.type}_${i}`} {...s.primary} />
      case "about_team":
        return (
          <About
            key={`${s.type}_${i}`}
            color="secondary"
            content={s.primary}
            {...props}
          />
        )
      case "article_gallery":
        return (
          <Articles
            key={`${s.type}_${i}`}
            articles={s.articles}
            {...s.primary}
          />
        )
      case "cta_button":
        return <CTAButton key={`${s.type}_${i}`} data={s.primary} />
      case "content_card":
        return (
          <ContentCardSlice
            key={`${s.type}_${i}`}
            main={s.primary}
            cards={s.fields}
          />
        )
      case "content_block":
        return (
          <ContentBlock key={`${s.type}_${i}`} data={s.block} list={s.fields} />
        )
      case "content":
        return <ContentSimple key={`${s.type}_${i}`} {...s.primary} />
      case "newsletter":
        return (
          <Newsletter key={`${s.type}_${i}`} content={s.primary} {...props} />
        )
      case "product_categories":
        return (
          <ProductCategoryGrid
            key={`${s.type}_${i}`}
            content={s.primary}
            categories={s.categories}
          />
        )
      case "product_grid":
        return (
          <ProductGrid
            key={`${s.type}_${i}`}
            content={s.primary}
            products={s.products}
          />
        )
      case "product":
        return <SingleProduct key={`${s.type}_${i}`} content={s.primary} />
      case "logo_banner":
        const { logo_banner_lead, logo_banner } = s.primary
        const fade =
          logo_banner?.variant.toLowerCase() === "high contrast" ? false : true
        return (
          <Logos
            key={`${s.type}_${i}`}
            align="center"
            color="primary"
            bg={fade ? "ice" : "white"}
            fade={fade}
            logos={logo_banner?.logos}
          >
            <Content content={logo_banner?.title} />
            <Content content={logo_banner_lead} />
          </Logos>
        )
      case "case_portfolio":
        return (
          <CasePortfolio
            key={`${s.type}_${i}`}
            cases_list={s.cases_list}
            {...props}
          />
        )
      case "cta":
        return (
          <CTASection
            key={`${s.type}_${i}`}
            bg="white"
            color="primary"
            content={s.primary}
            buttons={s.fields}
          />
        )
      default:
        console.warn(`No support for slice type ${s.type}`)
        return null
    }
  })
  return <>{slice}</>
}

SliceZone.propTypes = {
  slices: PropTypes.array.isRequired,
}

export default SliceZone
